var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 9.99966C18.25 14.5392 14.5578 18.222 10 18.222C5.44216 18.222 1.75 14.5392 1.75 9.99966C1.75 5.46009 5.44216 1.77734 10 1.77734C14.5578 1.77734 18.25 5.46009 18.25 9.99966Z",
    fill: "#C5DFFF",
    stroke: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46818 13.3251L5.55619 9.07676C5.53916 8.99743 5.61872 8.93191 5.69331 8.96384L8.19712 10.0355C8.24544 10.0562 8.30153 10.0359 8.32548 9.98914L9.97846 6.76008C10.0142 6.69019 10.1129 6.6869 10.1533 6.75425L12.0934 9.99241C12.1204 10.0374 12.1775 10.0539 12.2243 10.0303L14.3028 8.97967C14.3769 8.94219 14.4618 9.00622 14.4461 9.0878L13.6315 13.323C13.6225 13.3701 13.5813 13.4042 13.5333 13.4042H6.56595C6.51881 13.4042 6.47807 13.3712 6.46818 13.3251Z",
    fill: "#0054EC",
    stroke: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.cc48800816dd895f26a2663a9d3ed577.svg";
export { ForwardRef as ReactComponent };